<template>
  <div class="progress-wrapper" :style="styleVar">
    <div class="progress-move" ref="progressMove"></div>
  </div>
</template>
<script>
export default {
  props: ['progressConfig'],
  computed: {
    styleVar() {
      return {
        '--progress-animation-duration': this.progressConfig.duration,
      }
    },
  },
  async mounted() {
    await this.$nextTick();
    this.$refs.progressMove.addEventListener('animationend', () => {
      this.progressConfig.endCallback()
    })
  },
}
</script>

<style lang="scss" scoped>
.progress-wrapper {
  width: 400px;
  height: 10px;
  background: #000000;
  border-radius: 9px;
  .progress-move {
    width: 0;
    height: 100%;
    background: #F0CF96;
    border-radius: 9px;
    animation: progressAnimate var(--progress-animation-duration) 1;
    animation-fill-mode: forwards;
  }
}
@keyframes progressAnimate {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
</style>
